import { Zap, Clock } from "lucide-react";
import { daysLeft } from "../../lib/plans";

// Real-time credits HUD: trial ceiling, monthly allotment and add-on balance.
export function CreditsHud({ plan, compact = false }) {
  if (!plan) return <div className="h-24 rounded-2xl border border-white/10 bg-slate-950/60 animate-pulse" data-testid="credits-hud-loading" />;
  const trial = plan.status === "trialing";
  const inactive = !["trialing", "active"].includes(plan.status);
  const total = trial ? plan.trial_credits_total : inactive ? 0 : plan.plan_allotment;
  const left = trial ? plan.trial_credits_total - plan.trial_credits_used : plan.plan_credits;
  const pct = total ? Math.max(0, Math.min(100, (left / total) * 100)) : 0;
  const d = daysLeft(plan.trial_ends_at);
  return (
    <div className={`rounded-2xl border border-white/10 bg-slate-950/70 backdrop-blur-xl ${compact ? "p-4" : "p-6"}`} data-testid="credits-hud">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] text-cyan-400">{trial ? "TRIAL CREDITS" : inactive ? "NO ACTIVE PLAN" : "CREDITS THIS MONTH"}</p>
          <p className="mt-1 font-display text-3xl sm:text-4xl font-extrabold text-white tabular-nums" data-testid="credits-hud-balance">
            {left} <span className="text-lg text-slate-400 font-medium">/ {total || 0} credits remaining{trial ? "" : " this month"}</span>
          </p>
        </div>
        <span className="flex items-center gap-1 px-3 py-1 rounded-full bg-emerald-400/10 border border-emerald-400/30 text-emerald-300 font-mono text-xs" data-testid="credits-hud-available">
          <Zap size={12} /> {plan.available} usable
        </span>
      </div>
      <div className="mt-4 h-2.5 rounded-full bg-white/5 overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-cyan-400 via-purple-500 to-emerald-400 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-400 font-mono">
        <span data-testid="credits-hud-addon">+{plan.addon_credits} add-on credits{trial ? " (usable after trial)" : ""}</span>
        {trial && d != null && <span className="flex items-center gap-1 text-purple-300" data-testid="credits-hud-trial-days"><Clock size={12} /> Trial ends in {d} day{d === 1 ? "" : "s"} or after 10 credits</span>}
      </div>
    </div>
  );
}
